export default __webpack_public_path__ + "help-9645188a0e1ef86c1295c3c943217cc9.svg";